module.exports = {"images":{"categories":{"2016":{"header":"images/thing1.jpg","images":["images/thing1.jpg","images/thing2.jpg","images/grapeToGlass.png"]},"2017":{"header":"images/dark.jpg","images":["images/dark.jpg","images/tangled.jpg","images/light.jpg","images/life.jpg","images/home.jpg","images/flowers1.jpg","images/flowers2.jpg"]}}}}


//////////////////
// WEBPACK FOOTER
// ./src/images.json
// module id = 59
// module chunks = 0